import type { ToCurrentFolderNameByPlanId } from "./types";

export const toCurrentFolderNameByPlanId: ToCurrentFolderNameByPlanId = ({
  planRecords,
  folderRecords,
}) => {
  const folderNameById = new Map(
    folderRecords.map((folder) => [folder.id, folder.name]),
  );
  const currentFolderNameByPlanId = new Map<number, string>();
  for (const plan of planRecords) {
    const folderName =
      plan.folderId === null ? undefined : folderNameById.get(plan.folderId);
    if (folderName !== undefined) {
      currentFolderNameByPlanId.set(plan.id, folderName);
    }
  }
  return currentFolderNameByPlanId;
};
